// mockWebNanoId.js

module.exports.nanoid = () => {
  console.log('mockWebNanoId ');
  return Math.random().toString(36).substring(7);
};
